export function mapById(array: any[], key: string): any {
    if (!Array.isArray(array)) {
        return {} // Retourne un objet vide si array est null, undefined ou non valide
    }

    return array.reduce((acc, item) => {
        const keyParts = key.split(".") // Découper la clé imbriquée
        const id = keyParts.reduce((obj, part) => obj?.[part], item) // Accéder à la clé imbriquée

        if (id !== undefined) {
            acc[id] = item
        }

        return acc
    }, {})
}

export function groupById(array: any[], key: string): Record<string, any[]> {
    if (!Array.isArray(array)) {
        return {} // Retourne un objet vide si array est invalide
    }

    return array.reduce(
        (acc, item) => {
            const keyParts = key.split(".") // Découper la clé imbriquée
            const id = keyParts.reduce((obj, part) => obj?.[part], item) // Accéder à la clé imbriquée

            if (id !== undefined) {
                if (!acc[id]) {
                    acc[id] = [] // Initialiser un tableau si la clé n'existe pas encore
                }
                acc[id].push(item) // Ajouter l'élément au tableau correspondant
            }

            return acc
        },
        {} as Record<string, any[]>,
    )
}
